import * as React from 'react';
import './Login.css';
import logo from '../../assets/logo_w.png';
import { Link } from 'react-router-dom';
import { withLocalize, Translate } from "react-localize-redux";
import LanguageToggle from '../../_layout/languageToggle/LanguageToggle.jsx'

class Login extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      email: "",
      password: "",
      error: "",
      accountType: "admin"
    };
    this.handleChange = this.handleChange.bind(this)


  }

  componentDidMount() {
    if(this.props.match.params.type) {
      this.setState({accountType: this.props.match.params.type})
    }
  }

  componentWillReceiveProps(nextProps: any) {
    if(nextProps.match.params.type) {
      this.setState({accountType: nextProps.match.params.type})
    }
  }

  handleChange(event: any) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  login(email: string, password: string, accountType: string ) {
      fetch('public/login', {
        method: 'post',
        body: JSON.stringify({ email, password, accountType })
      })
      .then(results => {
        return results.json();
      }).then(data => {
        if(data.account.type == "user") {
          this.setState({error: "משתמש לא מורשה"})
          return
        }
        window.localStorage.setItem('account', JSON.stringify(data.account));
        this.props.history.push("/")
      }).catch((error) => {
        console.log(error)
        this.setState({error: error.message})
      })

  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  public render() {
    return (
      <div id="login-root" >
        <div className="right">
          <form>
            <img className="main_logo" src={logo} />
            <input type="email" autoFocus className="form-control" name="email" placeholder={this.props.translate("email").toString()} value={this.state.email}
            onChange={this.handleChange} />
            <input type="password" className="form-control" name="password" placeholder={this.props.translate("password").toString()} value={this.state.password}
              onChange={this.handleChange} />
            <button type="button" className={"primary-btn" + (this.validateForm()? "" : " off")} disabled={!this.validateForm()} onClick={this.login.bind(this, this.state.email, this.state.password, this.state.accountType)}><Translate id="login" /></button>
            <a><Translate id="forgotPassword" /></a>
            {this.state.accountType == "admin"? (
              <Link to="/login/client"><Translate id="clientLogin" /></Link>
            ) : (
              <Link to="/login/admin"><Translate id="adminLogin" /></Link>
            )}
            <h5>{this.state.error}</h5>
          </form>
          <LanguageToggle />
        </div>
        <div className="left"></div>
      </div>
    );
  }
}

export default withLocalize(Login)



// WEBPACK FOOTER //
// ./src/pages/login/Login.tsx